var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"engagement-wrapper"},[_c('EngagementList',{attrs:{"event-list":_vm.eventList}}),_c('div',{staticClass:"engagement-body"},_vm._l((_vm.eventList),function(event){return _c('Event',{key:event.id,attrs:{"event":event,"id":event.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }